var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _path, _path2, _path3, _path4, _path5, _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarclaysLogo = function SvgBarclaysLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "-40 0 160 91.213",
    id: "barclays_logo_svg__svg8"
  }, props), /*#__PURE__*/React.createElement("defs", {
    id: "barclays_logo_svg__defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient4908"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#24abe3",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop4904"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0383b8",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop4906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient1530"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ce3ad5",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop1526"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#3a6ef3",
      stopOpacity: 1
    },
    offset: 0.567,
    id: "barclays_logo_svg__stop1544"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#01c201",
      stopOpacity: 1
    },
    offset: 0.644,
    id: "barclays_logo_svg__stop1542"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#01c201",
      stopOpacity: 1
    },
    offset: 0.655,
    id: "barclays_logo_svg__stop1538"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#feea04",
      stopOpacity: 1
    },
    offset: 0.686,
    id: "barclays_logo_svg__stop1540"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffed2b",
      stopOpacity: 1
    },
    offset: 0.802,
    id: "barclays_logo_svg__stop1534"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e33636",
      stopOpacity: 1
    },
    offset: 0.85,
    id: "barclays_logo_svg__stop1536"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e33636",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop1528"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1530",
    id: "barclays_logo_svg__linearGradient1532",
    x1: 375.777,
    y1: 0,
    x2: 375.777,
    y2: 591.949,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(72.28049 0 0 72.8965 31.038 169.971)",
    spreadMethod: "pad",
    id: "barclays_logo_svg__linearGradient1101"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#918f90"
    },
    offset: 0,
    id: "barclays_logo_svg__stop1091"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8c7c7"
    },
    offset: 0.25,
    id: "barclays_logo_svg__stop1093"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e2e2e2"
    },
    offset: 0.5,
    id: "barclays_logo_svg__stop1095"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8c7c7"
    },
    offset: 0.75,
    id: "barclays_logo_svg__stop1097"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#918f90"
    },
    offset: 1,
    id: "barclays_logo_svg__stop1099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient3625"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1b5079",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop3613"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#296088",
      stopOpacity: 1
    },
    offset: 0.276,
    id: "barclays_logo_svg__stop3615"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#3b7ba1",
      stopOpacity: 1
    },
    offset: 0.427,
    id: "barclays_logo_svg__stop3617"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#4188ab",
      stopOpacity: 1
    },
    offset: 0.525,
    id: "barclays_logo_svg__stop3619"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#56a8c5",
      stopOpacity: 1
    },
    offset: 0.688,
    id: "barclays_logo_svg__stop3621"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#67c2dc",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop3623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient3609"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#91a9ca",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop3603"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6677b4",
      stopOpacity: 1
    },
    offset: 0.378,
    id: "barclays_logo_svg__stop3611"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#3a4cac",
      stopOpacity: 1
    },
    offset: 0.578,
    id: "barclays_logo_svg__stop3605"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#39388f",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop3607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient3601"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9d5ed",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop3597"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0b71ae",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop3599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient2693"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#83c4eb",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop2689"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2895d3",
      stopOpacity: 1
    },
    offset: 0.485,
    id: "barclays_logo_svg__stop2695"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2a4f99",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop2691"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient2687"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#75211f",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop2675"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ba2b29",
      stopOpacity: 1
    },
    offset: 0.276,
    id: "barclays_logo_svg__stop2677"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#db2e2a",
      stopOpacity: 1
    },
    offset: 0.427,
    id: "barclays_logo_svg__stop2679"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e43c31",
      stopOpacity: 1
    },
    offset: 0.525,
    id: "barclays_logo_svg__stop2681"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e74234",
      stopOpacity: 1
    },
    offset: 0.688,
    id: "barclays_logo_svg__stop2683"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e84636",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop2685"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-18.4903 -51.23466 50.8017 -18.6479 96.059 200.869)",
    spreadMethod: "pad",
    id: "barclays_logo_svg__linearGradient3239"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#eb4c3a"
    },
    offset: 0,
    id: "barclays_logo_svg__stop3241"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#df2e2a"
    },
    offset: 0.545,
    id: "barclays_logo_svg__stop3243"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#9e2b28"
    },
    offset: 0.837,
    id: "barclays_logo_svg__stop3245"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#802323"
    },
    offset: 1,
    id: "barclays_logo_svg__stop3247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(90.3371 91.107) rotate(-45 2.126 .623)",
    spreadMethod: "pad",
    id: "barclays_logo_svg__linearGradient3215"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#8dc8ec"
    },
    offset: 0,
    id: "barclays_logo_svg__stop3217"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#31a5e0"
    },
    offset: 0.376,
    id: "barclays_logo_svg__stop3219"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#258fcf"
    },
    offset: 0.579,
    id: "barclays_logo_svg__stop3221"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2b4c96"
    },
    offset: 1,
    id: "barclays_logo_svg__stop3223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(72.28049 0 0 72.8965 31.038 169.971)",
    spreadMethod: "pad",
    id: "barclays_logo_svg__linearGradient3189"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#918f90"
    },
    offset: 0,
    id: "barclays_logo_svg__stop3191"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8c7c7"
    },
    offset: 0.332,
    id: "barclays_logo_svg__stop3193"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e2e2e2"
    },
    offset: 0.523,
    id: "barclays_logo_svg__stop3195"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8c7c7"
    },
    offset: 0.693,
    id: "barclays_logo_svg__stop3197"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#918f90"
    },
    offset: 1,
    id: "barclays_logo_svg__stop3199"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(110.8607 -110.8607) rotate(70 4.213 1.877)",
    spreadMethod: "pad",
    id: "barclays_logo_svg__linearGradient3263"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f3dd25"
    },
    offset: 0,
    id: "barclays_logo_svg__stop3265"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e98329"
    },
    offset: 0.584,
    id: "barclays_logo_svg__stop3267"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e98329"
    },
    offset: 0.584,
    id: "barclays_logo_svg__stop3269"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e85f2a"
    },
    offset: 1,
    id: "barclays_logo_svg__stop3271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient1314"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6cd",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop1310"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2783b",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop1312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient1308"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fe5000",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop1296"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fc4e00",
      stopOpacity: 1
    },
    offset: 0.276,
    id: "barclays_logo_svg__stop1298"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f47c3c",
      stopOpacity: 1
    },
    offset: 0.427,
    id: "barclays_logo_svg__stop1300"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ef8a4d",
      stopOpacity: 1
    },
    offset: 0.525,
    id: "barclays_logo_svg__stop1302"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7a975",
      stopOpacity: 1
    },
    offset: 0.688,
    id: "barclays_logo_svg__stop1304"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4b786",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop1306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient1294"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fed74c",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop1290"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ef8a02",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop1292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient941"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4d229",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop937"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f98007",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient916"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cd0300",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop912"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d10101",
      stopOpacity: 1
    },
    offset: 0.276,
    id: "barclays_logo_svg__stop926"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f63c06",
      stopOpacity: 1
    },
    offset: 0.427,
    id: "barclays_logo_svg__stop924"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa5f04",
      stopOpacity: 1
    },
    offset: 0.525,
    id: "barclays_logo_svg__stop920"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcab91",
      stopOpacity: 1
    },
    offset: 0.688,
    id: "barclays_logo_svg__stop922"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbae90",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop914"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barclays_logo_svg__linearGradient894"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1c9c4",
      stopOpacity: 1
    },
    offset: 0,
    id: "barclays_logo_svg__stop890"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d83401",
      stopOpacity: 1
    },
    offset: 1,
    id: "barclays_logo_svg__stop892"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient894",
    id: "barclays_logo_svg__linearGradient896",
    x1: 162.34,
    y1: 128.999,
    x2: 219.604,
    y2: 68.603,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-127.59 5.536)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient916",
    id: "barclays_logo_svg__linearGradient918",
    x1: 124.165,
    y1: 115.283,
    x2: 163.343,
    y2: 155.71,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.79 -4.942)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient941",
    id: "barclays_logo_svg__linearGradient943",
    x1: 152.135,
    y1: 76.918,
    x2: 153.458,
    y2: 113.582,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.77953 0 0 3.77953 -454.286 -17.857)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient916",
    id: "barclays_logo_svg__linearGradient943-0",
    x1: 195.032,
    y1: 113.534,
    x2: 234.426,
    y2: 155.493,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-120.285 -4.487)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1314",
    id: "barclays_logo_svg__linearGradient1038",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.55018 0 0 .53024 -154.38 -95.686)",
    x1: 162.34,
    y1: 128.999,
    x2: 219.604,
    y2: 68.603
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient941",
    id: "barclays_logo_svg__linearGradient943-0-9",
    x1: 152.135,
    y1: 76.918,
    x2: 153.458,
    y2: 113.582,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-120.285 -4.487)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1294",
    id: "barclays_logo_svg__linearGradient1157",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.55018 0 0 .53024 -150.312 -101.127)",
    x1: 152.135,
    y1: 76.918,
    x2: 153.458,
    y2: 113.582
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1308",
    id: "barclays_logo_svg__linearGradient1166",
    x1: 284.028,
    y1: 410.534,
    x2: 432.619,
    y2: 570.73,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.14557 0 0 .1403 -84.135 -98.747)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient2693",
    id: "barclays_logo_svg__linearGradient1038-3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.4504 0 0 1.45533 -73.21 -140.825)",
    x1: 162.34,
    y1: 128.999,
    x2: 219.604,
    y2: 68.603
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient941",
    id: "barclays_logo_svg__linearGradient1157-2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.4504 0 0 1.45533 -62.487 -155.758)",
    x1: 152.135,
    y1: 76.918,
    x2: 153.458,
    y2: 113.582
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient2687",
    id: "barclays_logo_svg__linearGradient1166-7",
    x1: 284.028,
    y1: 410.534,
    x2: 432.619,
    y2: 570.73,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.38375 0 0 .38506 111.974 -149.228)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1314",
    id: "barclays_logo_svg__linearGradient1038-6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.67646 0 0 .63933 -52.676 -42.583)",
    x1: 162.34,
    y1: 128.999,
    x2: 219.604,
    y2: 68.603
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1294",
    id: "barclays_logo_svg__linearGradient1157-3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.67646 0 0 .63933 -47.674 -49.143)",
    x1: 152.135,
    y1: 76.918,
    x2: 153.458,
    y2: 113.582
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1308",
    id: "barclays_logo_svg__linearGradient1166-8",
    x1: 284.028,
    y1: 410.534,
    x2: 432.619,
    y2: 570.73,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.17898 0 0 .16916 33.693 -46.274)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient3609",
    id: "barclays_logo_svg__linearGradient1038-3-5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.30642 0 0 1.23597 .785 -135.447)",
    x1: 162.34,
    y1: 128.999,
    x2: 219.604,
    y2: 68.603
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient3601",
    id: "barclays_logo_svg__linearGradient1157-2-71",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.30642 0 0 1.23597 10.444 -148.13)",
    x1: 152.135,
    y1: 76.918,
    x2: 153.458,
    y2: 113.582
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1101",
    id: "barclays_logo_svg__linearGradient1066",
    gradientUnits: "userSpaceOnUse",
    x1: 64.987,
    y1: -11.117,
    x2: 183.578,
    y2: 53.142,
    gradientTransform: "translate(-59.88 123.096)"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1101",
    id: "barclays_logo_svg__linearGradient1068",
    gradientUnits: "userSpaceOnUse",
    x1: 64.987,
    y1: -11.117,
    x2: 183.578,
    y2: 53.142,
    gradientTransform: "translate(-66.987 123.096)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1101",
    id: "barclays_logo_svg__linearGradient1128",
    gradientUnits: "userSpaceOnUse",
    x1: 129.482,
    y1: 49.287,
    x2: 178.988,
    y2: 132.871
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient1530",
    id: "barclays_logo_svg__linearGradient1532-0",
    x1: 375.777,
    y1: 0,
    x2: 375.777,
    y2: 591.949,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#barclays_logo_svg__linearGradient4908",
    id: "barclays_logo_svg__linearGradient4910",
    x1: -156.068,
    y1: 220.576,
    x2: -97.479,
    y2: 313.51,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.26458 0 0 .26458 56.049 400.514)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "barclays_logo_svg__rect2218",
    d: "M-77.424 221.966h.142v3.496h-.142z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "barclays_logo_svg__rect2218-0",
    d: "M-77.424 221.966h.142v3.496h-.142z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "barclays_logo_svg__rect2218-2",
    d: "M-77.424 221.966h.142v3.496h-.142z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "barclays_logo_svg__rect2218-8",
    d: "M-77.424 221.966h.142v3.496h-.142z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "barclays_logo_svg__rect2218-5",
    d: "M-77.424 221.966h.142v3.496h-.142z"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "barclays_logo_svg__filter2655",
    x: -0.055,
    width: 1.11,
    y: -0.057,
    height: 1.114
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291,
    id: "barclays_logo_svg__feGaussianBlur2657"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "barclays_logo_svg__filter2655-0",
    x: -0.055,
    width: 1.11,
    y: -0.057,
    height: 1.114
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291,
    id: "barclays_logo_svg__feGaussianBlur2657-8"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "barclays_logo_svg__filter2655-8",
    x: -0.055,
    width: 1.11,
    y: -0.057,
    height: 1.114
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291,
    id: "barclays_logo_svg__feGaussianBlur2657-0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "barclays_logo_svg__filter2655-00",
    x: -0.055,
    width: 1.11,
    y: -0.057,
    height: 1.114
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291,
    id: "barclays_logo_svg__feGaussianBlur2657-7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "barclays_logo_svg__layer1",
    transform: "translate(260.327 -486.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "barclays_logo_svg__g3128",
    transform: "translate(-199.216 55.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "barclays_logo_svg__g3113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "barclays_logo_svg__layer1-4",
    transform: "translate(-32.924 -11.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "barclays_logo_svg__path4798",
    style: {
      fill: "#24abe3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".567037px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M12.664 442.307c-1.28-.023-2.355.108-3.035.315-.68.207-.963.491-1.104.633l-.142.14-.563.004c-.564.004-1.692.015-2.942.144-1.25.13-2.622.38-3.768.977a5.808 5.808 0 0 0-2.613 2.733c-.55 1.194-.73 2.638-.819 3.36h.001l-.09.721.215-.155c.215-.155.644-.465 1.516-.8.87-.333 2.184-.692 3.413-.632a5.17 5.17 0 0 1 3.27 1.361c.894.824 1.54 1.993 1.825 3.497a9.106 9.106 0 0 1-.537 5.154c-.752 1.814-2.184 3.604-3.83 4.618-1.647 1.015-3.508 1.255-4.988 1.242-1.48-.01-2.577-.274-3.413-.633-.836-.358-1.407-.81-1.694-1.037l-.287-.228.298-.263c.298-.262.895-.787 1.42-1.705.525-.92.979-2.232.93-3.604-.047-1.372-.596-2.804-1.836-3.771-1.241-.967-3.174-1.469-5.084-1.636-1.91-.167-3.795 0-6.11 1.074-2.315 1.074-5.06 3.055-6.946 5.8-1.886 2.745-2.911 6.253-3.424 9.284-.514 3.031-.513 5.585-.513 8.175 0 2.59 0 5.215.202 7.96.203 2.744.609 5.607 1.73 8.997 1.122 3.389 2.96 7.303 4.833 10.955.842 1.64 1.701 3.228 2.73 4.836a11.916 11.916 0 0 0 1.924-1.285c1.447-1.203 2.73-2.949 3.68-4.392.949-1.443 1.564-2.582 1.872-3.152l.309-.569-.338 1.705c-.337 1.704-1.013 5.114-1.953 7.717-.665 1.839-2.106 4.584-2.838 5.687.33-.142 1.451-.257 2.477-.546.495-.14 2.383-.95 3.797-2.181 1.386-1.206 2.297-2.827 2.993-3.726 1.553-2.008 2.836-3.754 3.785-5.197a40.656 40.656 0 0 0 1.874-3.152l.308-.57-.338 1.705c-.337 1.705-1.013 5.114-1.954 7.717-.94 2.603-2.147 4.4-3.94 7.278-.652 1.045-1.381 2.232-2.143 3.323 3.165 2.664 6.714 5.27 9.844 7.272 4.798 3.067 8.593 4.713 11.146 5.536 2.554.824 3.866.823 7.828-1.074s10.572-5.692 15.238-8.675c1.756-1.123 3.228-2.137 4.564-3.218-1.646-.572-3.144-2.377-4.419-4.047-1.522-1.995-2.73-3.792-3.67-6.395-.94-2.603-1.616-6.012-1.954-7.717l-.337-1.704.309.569c.308.57.923 1.709 1.872 3.152.95 1.443 2.232 3.19 3.786 5.198 1.553 2.009 3.377 4.279 5.399 5.485 1.107.66 3.651.655 3.934.27a20.057 20.057 0 0 1-2.627-4.99c-.941-2.603-1.616-6.013-1.954-7.717l-.338-1.705.308.57c.308.57.925 1.708 1.874 3.151.95 1.443 2.232 3.19 3.68 4.393a12.23 12.23 0 0 0 2.182 1.427c2.676-4.617 5.384-10.335 6.944-14.753 1.951-5.525 2.106-8.986 2.184-12.53.078-3.544.077-7.172-.137-10.012-.215-2.84-.645-4.892-1.247-6.813a27.275 27.275 0 0 0-2.368-5.442c-.99-1.73-2.196-3.4-3.527-4.642-1.33-1.24-2.786-2.052-4.39-2.458-1.606-.406-3.36-.406-5.073-.072-1.713.334-3.383 1.002-4.588 1.831-1.206.83-1.946 1.82-2.28 2.822-.334 1.003-.262 2.018 0 2.865a5.2 5.2 0 0 0 1.117 1.957c.4.43.745.609.918.698l.173.089-.501.387c-.501.388-1.504 1.163-2.631 1.55-1.128.388-2.38.388-3.532.233-1.152-.155-2.202-.465-3.199-1.124-.996-.659-1.94-1.667-2.485-2.446-.545-.78-.693-1.329-.766-2.802-.074-1.474-.074-3.87-.2-5.895-.127-2.026-.38-3.68-.73-4.983-.35-1.304-.798-2.258-1.523-3.156-.726-.9-1.73-1.742-2.974-2.253-1.245-.51-2.73-.688-4.01-.711zm-28.699 73.227c-.42-.444.378.433 0 0z"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1703"
  }, ".barclays_logo_svg__st1{fill:#7a7eae}.barclays_logo_svg__st2{fill:#639}.barclays_logo_svg__st3{fill:#120f22}.barclays_logo_svg__st4{fill:url(#barclays_logo_svg__SVGID_2_)}.barclays_logo_svg__st5{fill:url(#barclays_logo_svg__SVGID_3_)}.barclays_logo_svg__st6{fill:url(#barclays_logo_svg__SVGID_4_)}.barclays_logo_svg__st7{fill:#2d2868}.barclays_logo_svg__st8{fill:#453d76}.barclays_logo_svg__st9{fill:url(#barclays_logo_svg__SVGID_5_)}.barclays_logo_svg__st10{fill:url(#barclays_logo_svg__SVGID_6_)}.barclays_logo_svg__st11{fill:url(#barclays_logo_svg__SVGID_7_)}.barclays_logo_svg__st12{fill:url(#barclays_logo_svg__SVGID_8_)}.barclays_logo_svg__st13{fill:#484592}.barclays_logo_svg__st14{fill:none}.barclays_logo_svg__st15{fill:url(#barclays_logo_svg__SVGID_9_)}.barclays_logo_svg__st16{fill:url(#barclays_logo_svg__SVGID_10_)}.barclays_logo_svg__st17{fill:url(#barclays_logo_svg__SVGID_11_)}.barclays_logo_svg__st0{fill:#00aeef}")));
};
export default SvgBarclaysLogo;